import { render, staticRenderFns } from "./NDCPriceCheckModal.vue?vue&type=template&id=40fae7c8&scoped=true&"
import script from "./NDCPriceCheckModal.vue?vue&type=script&lang=js&"
export * from "./NDCPriceCheckModal.vue?vue&type=script&lang=js&"
import style0 from "./NDCPriceCheckModal.vue?vue&type=style&index=0&id=40fae7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fae7c8",
  null
  
)

export default component.exports